import { Link } from 'react-router'
import { Card, EmptyState } from '../ui'
import { Page } from './Page'
import { useSession } from '../lib/session'
import { useInstallPrompt } from '../lib/pwa'

export function MorePage() {
  const { me } = useSession()
  const links: Array<[string, string]> = [['/ranked', 'Ranked'], ['/search', 'Search stocks and filings'], ['/calendar', 'Calendar'], ['/alerts', 'Alerts'], ['/portfolio', 'Portfolio'], ['/billing', 'Billing and plan'], ['/account', 'Account']]
  if (me?.user.role === 'admin') links.push(['/admin', 'Admin console'], ['/admin/live', 'Admin · live rates'])
  const install = useInstallPrompt()
  return (
    <Page title="More">
      {install.mode === 'native' && <Card><div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}><span style={{ flex: 1 }}>Install BCEIE on this device for one-tap access and notifications.</span><button type="button" onClick={() => void install.install()} style={{ minHeight: 44, padding: '0 16px', borderRadius: 8, border: 'none', background: 'var(--primary)', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>Install app</button></div></Card>}
      {install.mode === 'ios' && <Card><p style={{ margin: 0 }}>To install BCEIE: tap <strong>Share</strong>, then <strong>Add to Home Screen</strong>.</p></Card>}
      <Card variant="flush">
        <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {links.map(([to, label]) => (
            <li key={to}><Link to={to} style={{ display: 'flex', alignItems: 'center', minHeight: 52, padding: '0 16px', borderBottom: '1px solid var(--row-divider)', color: 'var(--ink)', textDecoration: 'none', fontWeight: 500 }}>{label}</Link></li>
          ))}
        </ul>
      </Card>
    </Page>
  )
}

export function NotFoundPage() {
  return (
    <Page title="Page not found">
      <EmptyState kind="error" title="We couldn’t find that page" action={<Link to="/">Go to the dashboard</Link>} />
    </Page>
  )
}
